export default "/images/icon-ai-eye.gif?dcc5137dcb2c66f8115c6f9b779d038b";